import { useEffect } from "react";
import classNames from "classnames";
import { FormikProvider, useFormik } from "formik";
import { Button } from "@components/Button";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import FormikPassword from "../../components/FormikPassword";
import { useService } from "@/base/hooks/useService";
import { StorageService } from "@services/StorageService";
import {
  forgotPasswordReset,
  forgotPasswordRestore,
} from "@redux/forgotPassword/actions";
import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
} from "@validation/lengthConstants";
import { initialValues, validationSchema } from "./form";

import styles from "./index.module.scss";
import { toggleSignInModal } from "@redux/signIn/actions";
import { ToasterService } from "@services/ToastService";

const CreatePassword = ({ code, email, closeModal }) => {
  const dispatch = useDispatch();
  const toastService = useService(ToasterService);
  const { t } = useTranslation("new-password");
  const { t: t1 } = useTranslation("errors");
  const { t: t2 } = useTranslation("buttons");
  const storageService = useService(StorageService);
  const { error, isLoading, isSuccess } = useSelector(
    ({ forgotPasswordReducer }) => forgotPasswordReducer,
  );

  const handleSubmit = ({ password }) => {
    toastService.clearAll();
    dispatch(forgotPasswordRestore({ password, code, email }));
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (!isSuccess) return;

    dispatch(toggleSignInModal(true));
    storageService.clear();
    closeModal();
    toastService.success(t("SUCCESS"));
  }, [isSuccess]);

  useEffect(() => {
    return () => {
      dispatch(forgotPasswordReset());
    };
  }, []);

  useEffect(() => {
    const reuseError = t1("REUSE_ERROR");
    if (!error?.message) return;

    if (error?.message !== reuseError) return;
    toastService.error(reuseError);
  }, [error]);

  return (
    <div className={classNames("container", styles.content)}>
      <h3
        className={classNames(
          "text-primary h3-lx h4 text-medium text-center",
          styles.title,
        )}
      >
        {t("TITLE")}
      </h3>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <FormikPassword
            type="password"
            label="NEW_PASSWORD"
            name="password"
            min={MIN_PASSWORD_LENGTH}
            max={MAX_PASSWORD_LENGTH}
            wrapperClassName="mb-2"
            placeholder="NEW_PASSWORD"
            maxLength={MAX_PASSWORD_LENGTH}
          />
          <Button
            disabled={isLoading}
            color="primary"
            size="lg"
            className="w-100 text-medium"
          >
            {t2("CREATE")}
          </Button>
        </form>
      </FormikProvider>
    </div>
  );
};

export default CreatePassword;
